import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { ChildQuestion } from './ChildQuestion'
import useFieldValue from '../../../hooks/useFieldValue'
import { Field } from 'react-final-form'

const getChildQuestions = question => {
  if (!question.children_attributes) return []

  const childIndicator = Object.keys(question.children_attributes)[0]
  return question?.children_attributes?.[childIndicator]
}

export const RepeatGroupChildrenQuestions = ({ baseName, question, parentIndex, parentIndexSubType }) => {
  const value = useFieldValue(`answers.${parentIndex}.answer`)

  if (!value) return null

  const childCountArray = new Array(parseInt(value.selected)).fill(0)
  const childQuestions = getChildQuestions(question)

  return (
    <>
      {childCountArray.length ? (
        <div className="bg-neutral-300 p-6 flex flex-col gap-8">
          {childCountArray.map((_, childCountIndex) => (
            <div key={'child_' + childCountIndex}>
              <p className="font-bold text-xl">
                {question.payload.separator_text} {childCountIndex + 1}
              </p>
              {childQuestions.map((_, index) => {
                const alternativeBaseName = `${baseName}.sub_answers_attributes.${question.id}.${
                  childQuestions.length * childCountIndex + index
                }`
                return (
                  <Fragment key={`${childCountIndex}_${index}`}>
                    <Field
                      component="input"
                      className="hidden"
                      name={`${alternativeBaseName}.group_index`}
                      initialValue={childCountIndex}
                    />
                    <ChildQuestion
                      index={index}
                      alternativeBaseName={`${baseName}.sub_answers_attributes.${question.id}.${
                        childQuestions.length * childCountIndex + index
                      }`}
                      questions={childQuestions}
                      parentIndex={parentIndexSubType}
                    />
                  </Fragment>
                )
              })}
            </div>
          ))}
        </div>
      ) : null}
    </>
  )
}

RepeatGroupChildrenQuestions.propTypes = {
  baseName: PropTypes.string,
  parentIndex: PropTypes.number,
  parentIndexSubType: PropTypes.number,
  question: PropTypes.object
}
